module.exports = __webpack_public_path__ + "static/6322-1caa92dba477224401d12e494b222159.png";